<template>
    <div v-if="showModal">
        <div @click="$emit('closeModal')" class="fixed inset-0 z-10 overflow-y-auto bg-black bg-opacity-30">
            <div class="flex h-full justify-center items-center">
                <div @click.stop="" class="bg-white rounded-xl p-6 w-6/12 lg:w-4/12 xl:w-2/12 shadow-lg border border-light-gray">
                    <slot name="header"></slot>
                    <slot name="body"></slot>
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "BaseModal",
    props: {
        showModal: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["closeModal"],
}
</script>

<style scoped>

</style>